import { DOC2API_URL } from 'src/pages/APIs';

export function downloadViaBlob(url: string, filename: string): void {
  fetch(url)
    .then((response) => response.blob())
    .then((blob) => {
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(blobUrl);
    })
    .catch((error: any) => {
      console.error('Error downloading file:', error);
    });
}

export function downloadViaLink(url: string, filename: string): void {
  const link = document.createElement('a');
  link.download = filename;
  link.href = url;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

/**
 * Builds the standard document resource URL:
 * `{DOC2API_URL}/resource/document/{docId}/{docId}{suffix}?{tokenQueryParam}`
 */
export function buildDocumentResourceUrl(
  docId: string,
  suffix: string,
  tokenQueryParam: string,
): string {
  return (
    DOC2API_URL +
    '/resource/document/' +
    docId +
    '/' +
    docId +
    suffix +
    '?' +
    tokenQueryParam
  );
}

/**
 * Downloads a document using the standard `/resource/document/` path with fetch+blob.
 * This is the most common download pattern across the app.
 */
export function downloadDocumentFile(
  docId: string,
  filename: string,
  tokenQueryParam: string,
  suffix?: string,
): void {
  try {
    const ext = suffix ?? ('.' + (filename ? filename.split('.').pop() : 'pdf'));
    const url = buildDocumentResourceUrl(docId, ext, tokenQueryParam);
    if (!url) return;
    downloadViaBlob(url, filename);
  } catch (err: any) {
    console.error(err);
  }
}

/**
 * Downloads a file using the resource path (e.g. row['doc_path']).
 * `{DOC2API_URL}/resource/{resourcePath}?{tokenQueryParam}`
 */
export function downloadResourceFile(
  resourcePath: string,
  filename: string,
  tokenQueryParam: string,
): void {
  try {
    if (!resourcePath) return;
    const url = DOC2API_URL + '/resource/' + resourcePath + '?' + tokenQueryParam;
    downloadViaBlob(url, filename);
  } catch (err: any) {
    console.error(err);
  }
}
